import { render, staticRenderFns } from "./AffiliateSubscriptionList.vue?vue&type=template&id=2c94d3d0&"
import script from "./AffiliateSubscriptionList.vue?vue&type=script&lang=js&"
export * from "./AffiliateSubscriptionList.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateSubscriptionList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports